/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loading[_ngcontent-%COMP%]{padding:80px 10px}.loading[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:4em}.loading[_ngcontent-%COMP%]   .loading-text[_ngcontent-%COMP%]{margin-top:20px;font-size:1.2em}@media (min-width:992px){.room-wide[_ngcontent-%COMP%]{display:flex}.room-wide[_ngcontent-%COMP%]   .establishment-image[_ngcontent-%COMP%]{min-width:400px}.room-wide[_ngcontent-%COMP%]   .caption[_ngcontent-%COMP%]{flex-grow:1}.txt5[_ngcontent-%COMP%]{min-height:8em;margin-bottom:1em;overflow:hidden}}"];
export { styles as styles };
